import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const Home = () => {
  const { t } = useLanguage();

  return (
    <div className="home">
      <h1 className="hero-title">
        {t('heroTitle1')} <span>$15,000</span> {t('heroTitle2')}
      </h1>
      
      <p className="hero-desc">{t('heroDesc')}</p>
      
      <div className="hero-buttons">
        <a href="https://roobet.com/?ref=fastbonus" target="_blank" rel="noopener noreferrer" className="btn-primary">
          {t('joinRoobet')}
        </a>
        <Link to="/leaderboard" className="btn-secondary">
          {t('viewLeaderboard')}
        </Link>
      </div>

      <section className="offers-section">
        <div className="offers-grid">
          
          {/* Offre 1 */}
          <div className="offer-card">
            <div className="offer-icon">🎁</div>
            <div className="offer-header">
              <h3 className="offer-title">{t('offer1Title')}</h3>
              <p className="offer-title">{t('offer1Subtitle')}</p>
            </div>
            <div className="offer-details">
              <div className="offer-item">
                <span className="offer-check">✓</span>
                <span>{t('offer1Line1')} <strong>"fastbonus"</strong></span>
              </div>
              <div className="offer-item">
                <span className="offer-check">✓</span>
                <span>{t('offer1Line2')} <strong>2000$</strong></span>
              </div>
              <div className="offer-item">
                <span className="offer-check">✓</span>
                <span>{t('offer1Line3')} <strong>Discord</strong></span>
              </div>
            </div>
            <a href="https://roobet.com/?ref=fastbonus" target="_blank" rel="noopener noreferrer" className="offer-btn">
              {t('joinRoobet')}
            </a>
          </div>

          {/* Offre 2 */}
          <div className="offer-card">
            <div className="offer-icon">🏆</div>
            <div className="offer-header">
              <h3 className="offer-title">{t('offer2Title')}</h3>
              <p className="offer-title">{t('offer2Subtitle')}</p>
            </div>
            <div className="offer-details">
              <div className="offer-item">
                <span className="offer-check">✓</span>
                <span>{t('offer2Line1')} <strong>"fastbonus"</strong></span>
              </div>
              <div className="offer-item">
                <span className="offer-check">✓</span>
                <span>{t('offer2Line2')} <strong>Roobet.com</strong> {t('offer2Line2b')}</span>
              </div>
              <div className="offer-item">
                <span className="offer-check">✓</span>
                <span>{t('offer2Line3')} <strong>{t('offer2Line3b')}</strong></span>
              </div>
            </div>
            <Link to="/leaderboard" className="offer-btn">
              {t('viewLeaderboard')}
            </Link>
          </div>

          {/* Offre 3 */}
          <div className="offer-card">
            <div className="offer-icon">🎰</div>
            <div className="offer-header">
              <h3 className="offer-title">{t('offer3Title')}</h3>
              <p className="offer-title">{t('offer3Subtitle')}</p>
            </div>
            <div className="offer-details">
              <div className="offer-item">
                <span className="offer-check">✓</span>
                <span>{t('offer3Line1')} <strong>"fastbonus"</strong></span>
              </div>
              <div className="offer-item">
                <span className="offer-check">✓</span>
                <span>{t('offer3Line2')} <strong>{t('offer3Line2b')}</strong> {t('offer3Line2c')}</span>
              </div>
              <div className="offer-item">
                <span className="offer-check">✓</span>
                <span>{t('offer3Line3')} <strong>{t('offer3Line3b')}</strong> {t('offer3Line3c')}</span>
              </div>
            </div>
            <a href="https://discord.com/invite/fastbonus" target="_blank" rel="noopener noreferrer" className="offer-btn">
              {t('joinDiscord')}
            </a>
          </div>

        </div>
      </section>

      <section className="discord-cta">
        <p>{t('discordCta')} <span>Discord</span> {t('discordCtaEnd')}</p>
        <a href="https://discord.com/invite/fastbonus" target="_blank" rel="noopener noreferrer" className="discord-btn">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
          </svg>
          {t('joinDiscord')}
        </a>
      </section>
    </div>
  );
};

export default Home;
